module.exports = __webpack_public_path__ + "media/images/athletes/1641-f5d21feda64a605a07efa5da99c4afce.png";